import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=53a7319c&"
import script from "./PasswordResetView.vue?vue&type=script&lang=js&"
export * from "./PasswordResetView.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=53a7319c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports